import { AssistentItem } from '../assistent_config';
import { DateneingabeAnAbreiseDetailWrapper } from '../../DateneingabeAnAbreiseDetailWrapper';
import { DateneingabeCO2Scope3Auswahl } from '../../DateneingabeCO2Scope3AuswahlNew';
import { DateneingabePendelnKampagneWrapper } from '../../DateneingabePendelnKampagneWrapper';
import { getAssistentConfigWasser } from './assistent_config_wasser';
import { getCO2Scope3StructureAllgemein, getCO2Scope3StructureNachgelagert, getCO2Scope3StructureVorgelagert } from '../../functions/getCO2Scope3Structure';
import { IDs } from '../../../../helpers/IDs';
import * as React from 'react';
import { TriggerService } from '../../../../core/trigger/trigger_service';
import { WFormData } from '../../../../core/forms/WFormFramework';

export function getAssistentConfigCO2Scope3(standort: any, data: any, jahr: number, customCfg?: AssistentItem): AssistentItem {
    data = data || {};
    const elementAuswahl: JSX.Element = (
        <DateneingabeCO2Scope3Auswahl
            data={data}
            standortSelected={standort}
            jahrFix={jahr}
            hideJahr
            // showDetailierteErfassung
            showHelpIcon
        />
    );
    return {
        // collapsible: 'co2Scope3Items',
        gliederung: '9.',
        name: 'CO₂-Fußabdruck - Scope 3',
        // description: 'Bitte Wählen sie die für den Scope 3 zu erfassenden Daten',
        description: '',
        type: 'CustomGroupElement',
        customElements: [elementAuswahl],
        configFlag: 'inputScope3',
        colBg: '#c5d1ad',
        ...(customCfg || {})
    };
}

function getCo2BtnLabel(entity: string, titel: string): string {
    return {
        [IDs.ENT_CO2_SCOPE3_GUETER_EINKAUF]: 'Neue Güter erfassen',
        [IDs.ENT_ENERGIEDATEN_WASSER]: 'Neuen Leitungs-/Abwasser-Datensatz erfassen',
        [IDs.ENT_CO2_SCOPE3_GUETER_KAPITAL]: 'Neue Kaptialgüter erfassen',
        [IDs.ENT_CO2_SCOPE3_TRANSPORT_VORGELAGERT]: 'Neue Transporte erfassen',
        [IDs.ENT_CO2_SCOPE3_ABFALL]: 'Neue Abfälle erfassen',
        [IDs.ENT_CO2_SCOPE3_REISEN]: 'Neue Geschäftsreisen erfassen',
        [IDs.ENT_CO2_SCOPE3_PENDELN]: 'Neue Arbeitnehmer:in erfassen',
        [IDs.ENT_CO2_SCOPE3_PENDELN_KAMPAGNE]: 'Neuen Datensatz erfassen',
        [IDs.ENT_CO2_SCOPE3_TRANSPORT_NACHGELAGERT]: 'Neue Transporte erfassen',
        [IDs.ENT_CO2_SCOPE3_ANGEMIETETE_SACHANLAGEN]: 'Neuen Datensatz für die Kategorie erfassen',
        [IDs.ENT_CO2_SCOPE3_PRODUKTE_VERARBEITUNG]: 'Neuen Datensatz für die Kategorie erfassen',
        [IDs.ENT_CO2_SCOPE3_PRODUKTE_NUTZUNG]: 'Neuen Datensatz für die Kategorie erfassen',
        [IDs.ENT_CO2_SCOPE3_PRODUKTE_LEBENSZYKLUS]: 'Neuen Datensatz für die Kategorie erfassen',
        [IDs.ENT_CO2_SCOPE3_VERMIETETE_SACHANLAGEN]: 'Neuen Datensatz für die Kategorie erfassen',
        [IDs.ENT_CO2_SCOPE3_VERMIETETE_SACHANLAGEN_RAEUMLICHKEITEN]: 'Neuen Datensatz für die Kategorie erfassen',
        [IDs.ENT_CO2_SCOPE3_VERMIETETE_SACHANLAGEN_FAHRZEUGE]: 'Neuen Datensatz für die Kategorie erfassen',
        [IDs.ENT_CO2_SCOPE3_VERMIETETE_SACHANLAGEN_TECHNIK]: 'Neuen Datensatz für die Kategorie erfassen',
        [IDs.ENT_CO2_SCOPE3_FRANCHISE]: 'Neuen Datensatz für die Kategorie erfassen',
        [IDs.ENT_CO2_SCOPE3_INVESTITION]: 'Neuen Datensatz für die Kategorie erfassen',
        [IDs.ENT_CO2_SCOPE3_EMITTENTEN]: 'Neuen Datensatz erfassen',
        [IDs.ENT_ANABREISE]: 'Neue An-/Abreise erfassen'
    }[entity] || `Neuen Datensatz für ${titel} erfassen`;
}

export function getAssistentConfigCO2Scope3Item(
    auswahlItem: string, data: any, triggerService: TriggerService, bereichKey: string, modul?: string
): AssistentItem {
    data = data || {};
    const co2_fussabdruck: number = ((data[IDs.ENT_KONFIGURATION] || [])[0] || {}).co2_fussabdruck_orig;
    const co2_fussabdruck_modus_ghg: string = ((data[IDs.ENT_KONFIGURATION] || [])[0] || {}).co2_fussabdruck_modus;
    const groupNumber: number = modul === 'cfm' ? 3 : 9;
    const structAll = [
        ...getCO2Scope3StructureVorgelagert(bereichKey, modul),
        ...getCO2Scope3StructureNachgelagert(bereichKey, modul),
        ...getCO2Scope3StructureAllgemein()
    ];
    const struct: any = structAll.find((s: any) => s.key === auswahlItem && !s.ignore);
    if (modul === 'cfm' && co2_fussabdruck !== 1) {
        return null;
    }
    if (!struct) {
        // console.log('S?', structAll, auswahlItem);
        return;
    }
    if (struct.modus) {
        if (struct.modus === 'ghg' && co2_fussabdruck_modus_ghg !== 'ghg') {
            return null;
        }
        if (struct.modus === 'simple' && co2_fussabdruck_modus_ghg === 'ghg') {
            return null;
        }
    }
    const entity = struct.entity || `co2_scope3_${auswahlItem}`;
    let name = struct.name_short || struct.name;
    let infoTextKey: string;
    if (entity === IDs.ENT_ANABREISE) {
        infoTextKey = 'Geführter Modus - Hinweis Besucherumfrage';
    } else if (entity === IDs.ENT_CO2_SCOPE3_PENDELN_KAMPAGNE) {
        infoTextKey = 'Geführter Modus - Hinweis Mitarbeiterumfrage';
    }
    const split = name.split(' ');
    let gliederung = split[0].endsWith('.') ? `${groupNumber}.${split[0].replace('.', '')}` : `${groupNumber}.${split[0] || ''}`;
    if (struct.force_name) {
        gliederung = '';
    } else {
        split.splice(0, 1);
    }
    const titel = split.join(' ');
    const item: any = {
        group: 'co2Scope3Items',
        gliederung,
        name: titel,
        dataName: titel,
        description: `Dies ist das Formular zur Eingabe der ${titel}-Daten.`,
        type: 'EntityForm',
        addLabel: getCo2BtnLabel(entity, titel),
        entity,
        configFlag: 'inputScope3',
        style: { marginLeft: 18 },
        infoTextKey,
        customOnSaveDone: (ent: string, dataItem: any) => {
            // console.log('getAssistentConfigCO2Scope3', 'customOnSaveDone', ent);
            triggerService.fire('reload', ent);
        },
        colBg: modul === 'cfm' ? undefined : '#c5d1ad'
    }
    if (entity === IDs.ENT_ENERGIEDATEN_WASSER) {
        return getAssistentConfigWasser(data, triggerService, item);
    }
    return {
        ...(item || {}),
        bundleFilterFunc: (bundle: any, dat: any) => {
            if (entity === IDs.ENT_CO2_SCOPE3_GUETER_EINKAUF) {
                bundle.art_tid = dat[IDs.ENT_CO2_SCOPE3_FAKTOREN_MATERIAL];
            }
        },
        onFormChangeInteractive: (formData: WFormData, onValueChange: (name: string, value: any) => void) =>
            onFormChangeInteractiveCO2(entity, bereichKey, formData, onValueChange),
        disableFieldSelectDefaultOptions: getDisableFieldSelectDefaultOptions(entity),
        customCssStyle: {
            ...(entity === IDs.ENT_CO2_SCOPE3_GUETER_EINKAUF
                ? {
                    formFieldSelect: {
                        classOption: {
                            '-2': { fontStyle: 'italic', fontWeight: 'bold' },
                            '-1': { fontStyle: 'italic', fontWeight: 'bold' }
                        }
                    }
                }
                : {}
            )
        },
        getExtraElement: (tmp1: boolean, tmp2: any, tmp3: number, tmp4: any, values: any, tmp5: (values: any) => void): JSX.Element => {
            if (entity === IDs.ENT_ANABREISE) {
                return <DateneingabeAnAbreiseDetailWrapper
                    rowTid={(values || {}).tid}
                    data={data}
                />
            }
            if (entity === IDs.ENT_CO2_SCOPE3_PENDELN_KAMPAGNE) {
                return <DateneingabePendelnKampagneWrapper
                    rowTid={(values || {}).tid}
                    data={data}
                />
            }
            return null;
        }
    };
}

function getDisableFieldSelectDefaultOptions(entity: string): any {
    switch (entity) {
        case IDs.ENT_CO2_SCOPE3_PENDELN:
        // no break
        case IDs.ENT_CO2_SCOPE3_TRANSPORT_NACHGELAGERT:
        // no break
        case IDs.ENT_CO2_SCOPE3_TRANSPORT_VORGELAGERT:
            return {
                teilstrecken: true
            };
        case IDs.ENT_CO2_SCOPE3_REISEN:
            return {
                firmenfahrzeug: true,
                teilstrecken: true
            };
        default: return {};
    }
}

export function onFormChangeInteractiveCO2(entity: string, bereichKey: string, formData: WFormData, onValueChange: (name: string, value: any) => void): void {
    if (entity === IDs.ENT_ANABREISE || entity === IDs.ENT_CO2_SCOPE3_PENDELN_KAMPAGNE) {
        const values = formData.getAllValues();
        if (!values.kennung && values.standort_tid > 0) {
            const kennung = (bereichKey || 'null') + '_' + values.standort_tid + '_' + new Date().getTime();
            onValueChange('kennung', kennung);
        }
    }
}